import styled, { keyframes } from "../../../styled/index";
import { shadeAlternate } from "../../../styled/helpers";
import { CS } from "../../../styles/index";
export const Wrapper = styled("div") `
  width: 100%;
`;
export const Content = styled("div") `
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  ${CS.shadow.light.two};
`;
export const ScrollX = styled("div") `
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;
export const Inner = styled("div") `
  min-width: max-content;
  padding-left: 12px;       /* gutter */
  box-sizing: border-box;
`;
export const Loader = styled("div") `
  padding: 30px 0;
  color: ${({ theme }) => theme.box.text};
`;
// TOP
export const TopWrapper = styled("div") `
  display: flex;
`;
export const TopButton = styled("div") `
  font-weight: 600;
  padding: 12px 16px;
  text-align: center;
  flex-grow: 1;
  cursor: pointer;
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.03, theme.box.background)};
  }
`;
// DROP
export const DropWrapper = styled("div") `
  display: ${({ active }) => active ? "block" : "none"};
  width: 100%;
  padding: 20px;
  border-top: 1px solid ${({ theme }) => theme.box.border};
`;
export const DropSection = styled("div") `
  border-bottom: 1px dashed ${({ theme }) => theme.box.border};
  padding-bottom: 20px;
  margin-bottom: 20px;
  &:last-child {
    padding-bottom: 0;
    margin-bottom: 0;  
    border: none;
  } 
`;
export const DropLRContent = styled("div") `
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  
  > * {
    &:first-child {
      margin-bottom: 10px;
    }
  }
  
  @media (min-width: 600px) {
    flex-direction: row;
    align-items: center;
    > * {
      &:first-child {
        margin-bottom: 0;
        margin-right: 20px;
        min-width: 100px;
        width: 100px;
      }
      &:last-child {
        flex-grow: 1;
      }
    }
  }
  
`;
// CONTROLS
export const ControlWrapper = styled("div") `
  ${CS.shadow.light.two};
  display: flex;
  font-size: 14px;
  font-weight: 600;
  max-width: 600px;
  margin: 20px auto 0 auto;
  border-radius: 30px;
  overflow: hidden;
  > * {
    padding: 8px;
  }
`;
export const ControlButton = styled("div") `
  flex: 1;
  flex-grow: 1;
  text-align: center;
  cursor: pointer;
  background: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.03, theme.box.background)};
  }
`;
export const ControlPageCount = styled("div") `
  background: ${({ theme }) => theme.box.background};
  width: 140px;
  text-align: center;

  & input {
    margin-top: -4px;
    appearance: none;
    border-top: unset;
    border-left: unset;
    border-right: unset;
    text-align: center;
    border-bottom: 2px solid #212121;
  }
`;
// TABLE
export const Table = styled("table") `
  background: ${({ theme }) => theme.box.background};
  width: 100%;
  border-collapse: collapse;
  th, td {
    padding: 10px 5px;
    &:first-child {
      padding-left: 10px;
    }
    &:last-child {
      padding-right: 10px;
    }
  }
`;
// TABLE HEAD
export const TableHead = styled("thead") `
  background: ${({ theme }) => shadeAlternate(0.03, theme.box.background)}; 
`;
export const TableHeadRow = styled("tr") `
  border-top: 1px solid ${({ theme }) => theme.box.border};
  border-bottom: 1px solid ${({ theme }) => theme.box.border};
`;
export const TableHeadCell = styled("th") `
  font-size: ${({ theme }) => theme.font.size}px;
  font-weight: 600;
  text-align: left;
 
`;
// TABLE BODY
export const TableBody = styled("tbody") `
  
`;
export const TableRow = styled("tr") `
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.box.border};
  &:last-child { border-bottom: none; }
  &:hover {
    background: ${({ theme }) => shadeAlternate(0.02, theme.box.background)};
  }
`;
export const TableCell = styled("td") `
  position: relative;
  font-size: ${({ theme }) => theme.font.size}px;
  line-height: 1.3;
  text-align: left;
  vertical-align: middle;
`;
const pulse = keyframes `
  from {
    transform: scale(0.9) translateY(-50%);
  }
  to {
    transform: scale(1) translateY(-50%);
  }
`;
export const TableCellAlert = styled("span") `
  position: absolute;
  top: 50%;
  left: -9px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 10px;
  text-align: center;
  border-radius: 3px;
  background: ${({ theme }) => shadeAlternate(0.05, theme.colors.primary)};
  color: ${({ theme }) => theme.colors.primary_text};
  animation: ${pulse} 0.4s linear infinite;
  animation-direction: alternate-reverse;
`;
//# sourceMappingURL=components.js.map